import { Check } from 'lucide-react'
import { useLocale } from '../../context/LocaleContext'

export default function JourneySteps({ current }: { current: 'account' | 'review' }) {
  const { t } = useLocale()
  const currentIndex = current === 'account' ? 0 : 1
  return <ol className="sl-journey-steps" aria-label={t('Étapes de souscription', 'Subscription steps')}>
    {[t('Compte', 'Account'), t('Confirmation', 'Review'), t('Paiement', 'Payment')].map((label, index) => <li key={label} aria-current={index === currentIndex ? 'step' : undefined} data-completed={index < currentIndex || undefined}>
      <span aria-hidden="true">{index < currentIndex ? <Check size={13} /> : index + 1}</span><span>{label}</span>{index < currentIndex && <span className="sr-only">{t('terminé', 'completed')}</span>}
    </li>)}
  </ol>
}
